import { render, staticRenderFns } from "./EmissionTable.vue?vue&type=template&id=de0f0856&scoped=true"
import script from "./EmissionTable.vue?vue&type=script&lang=js"
export * from "./EmissionTable.vue?vue&type=script&lang=js"
import style0 from "./EmissionTable.vue?vue&type=style&index=0&id=de0f0856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de0f0856",
  null
  
)

export default component.exports